import { MessageCircle } from "lucide-react";
import { useSiteContent } from "@/contexts/SiteContentContext";

const WhatsAppButton = () => {
  const { content } = useSiteContent();
  const phone = (content?.contact?.whatsapp_number || "+34657138915").replace(/[^+\d]/g, "");
  const url = `https://wa.me/${phone.replace(/^\+/, "")}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp"
      className="fixed right-2 bottom-2 z-[2147483646] group inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 text-white shadow-[0_14px_30px_rgba(16,185,129,0.45)] hover:bg-emerald-600 transition-colors px-5 py-3.5 min-w-[150px]"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm font-medium">WhatsApp</span>
    </a>
  );
};

export default WhatsAppButton;
